module.exports = __webpack_public_path__ + "app/principal/widgets/order-config/order-draggable-table-2JOh5gAJ.html";